module.exports = __webpack_public_path__ + "a796b16d8f1c42862953487aed9bd660.svg";